import { store } from "../store/store";
import { OrganizationWhitelabelDetails } from "../store/slices/authUserSlice";

// Maps a hostname (or whitelabel frontend_domain) to a known agency slug
export const agencyFromHostname = (hostname: string): string | null => {
  if (hostname.includes('authoritydigest')) return 'authoritydigest';
  if (hostname.includes('unifiedmmg')) return 'unifiedmmg';
  if (hostname.includes('instantestimate')) return 'instantestimate';
  if (hostname.includes('askspectra') || hostname.includes('spectratechconsultants')) return 'spectra';
  return null;
};

export const getWhitelabelSettings = (): OrganizationWhitelabelDetails | null => {
  return store.getState().authUser?.userDetails?.organization?.whitelabel || null;
};

/**
 * The agency slug for the current context.
 *
 * When signed in, branding always follows the account's own whitelabel
 * settings (from the backend): a whitelabel account shows its partner's
 * branding on any domain, and a regular account never shows partner branding —
 * regardless of what localStorage or the URL say. The device-level fallbacks
 * (?agency= link, localStorage, hostname) only apply while logged out
 * (login / MFA screens), where the account isn't known yet.
 */
export const getAgency = (): string | null => {
  const organization = store.getState().authUser?.userDetails?.organization;
  if (organization) {
    const whitelabel = organization.whitelabel;
    if (!whitelabel) return null;
    // Unknown partner domains still count as whitelabel ("whitelabel" slug);
    // the header falls back to the partner's logo_url for those.
    return agencyFromHostname(whitelabel.frontend_domain || "") || 'whitelabel';
  }

  const stored = localStorage.getItem("agency");
  if (stored) return stored;
  return agencyFromHostname(window.location.hostname);
};

export const isWhiteLabel = (): boolean => getAgency() !== null;
